import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';

import { getLoginState, isSayWeeeApp } from '@/utils/tool';

import useExpRedirect from './useExpRedirect';

export default function useNeedLogin() {
  const router = useRouter();
  const { lang } = useTranslation('common');
  const doExperimentRedirect = useExpRedirect();

  function checkIsLogin() {
    const isLogin: boolean = getLoginState();
    const isInApp = isSayWeeeApp();
    if (!isLogin) {
      let destUrl = doExperimentRedirect(
        `/${lang}/account/login?redirect_url=${encodeURIComponent(router.asPath)}`,
        isInApp,
        window.location.href
      );
      if (isInApp) {
        window.location.href = destUrl;
      } else {
        router.push(destUrl);
      }
    }
    return isLogin;
  }

  return {
    checkIsLogin
  };
}
